import { useState } from 'react';
import './App.css';
import DrawingCanvas from "./DrawingCanvas"
import PredictionResults from './PredictionResults';
import { Title } from '@mantine/core';

function App() {
  const initialArray = new Float64Array([0.0]);
  const [probs, setProbs] = useState<Float64Array>(initialArray);

  return (
    <div className="App">
      <Title className='main-title'>Brique.rs MNIST demo</Title>
      <div className="container">
        <DrawingCanvas width={500} height={500} penWidth={25} setProb={setProbs}/>
        <PredictionResults probs={probs}/>
      </div>
    </div>
  );
}

export default App;
